package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.auth.TrashItem
import br.com.htms.inspeccaocampo.platform.formatDateTimeBr
import br.com.htms.inspeccaocampo.shared.ui.components.CenteredAppDialog
import kotlinx.coroutines.launch

@Composable
fun SharedTrashPanel(onMessage: (String) -> Unit) {
    var aberto by remember { mutableStateOf(false) }
    var items by remember { mutableStateOf<List<TrashItem>>(emptyList()) }
    var loading by remember { mutableStateOf(false) }
    var loadedOnce by remember { mutableStateOf(false) }
    var confirmPurge by remember { mutableStateOf<TrashItem?>(null) }
    val scope = rememberCoroutineScope()

    fun recarregar() {
        scope.launch {
            loading = true
            AuthApi.listTrash()
                .onSuccess {
                    items = it
                    loadedOnce = true
                }
                .onFailure { onMessage(it.message ?: "Falha ao carregar lixeira") }
            loading = false
        }
    }

    fun recuperar(item: TrashItem) {
        scope.launch {
            AuthApi.restoreTrash(item.type, item.id)
                .onSuccess {
                    onMessage("Item recuperado.")
                    recarregar()
                }
                .onFailure { onMessage(it.message ?: "Falha ao recuperar") }
        }
    }

    fun apagarDefinitivo(item: TrashItem) {
        scope.launch {
            AuthApi.purgeTrash(item.type, item.id)
                .onSuccess {
                    onMessage("Item apagado definitivamente.")
                    recarregar()
                }
                .onFailure { onMessage(it.message ?: "Falha ao apagar") }
        }
    }

    LaunchedEffect(aberto) {
        if (aberto && !loadedOnce && !loading) recarregar()
    }

    confirmPurge?.let { alvo ->
        CenteredAppDialog(
            onDismissRequest = { confirmPurge = null },
            title = "Apagar definitivo",
            text = "Apagar \"${alvo.label}\" definitivamente? Esta ação não pode ser desfeita.",
            confirmLabel = "Apagar",
            onConfirm = {
                apagarDefinitivo(alvo)
                confirmPurge = null
            },
            dismissLabel = "Cancelar"
        )
    }

    Card(
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant),
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            PortalOutlinedButton(
                onClick = { aberto = true },
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(
                    if (loadedOnce) "Lixeira (${items.size})" else "Lixeira"
                )
            }
            Text(
                "Itens excluídos do Histórico ficam 7 dias aqui — recuperar ou apagar definitivo.",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
        }
    }

    if (aberto) {
        Dialog(
            onDismissRequest = { aberto = false },
            properties = DialogProperties(
                usePlatformDefaultWidth = false,
                dismissOnBackPress = true,
                dismissOnClickOutside = true
            )
        ) {
            Box(modifier = Modifier.fillMaxSize()) {
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .background(Color.Black.copy(alpha = 0.45f))
                        .clickable(
                            interactionSource = remember { MutableInteractionSource() },
                            indication = null,
                            onClick = { aberto = false }
                        )
                )
                Card(
                    modifier = Modifier
                        .align(Alignment.Center)
                        .padding(horizontal = 16.dp, vertical = 20.dp)
                        .widthIn(max = 900.dp)
                        .fillMaxWidth()
                        .fillMaxHeight(0.9f),
                    shape = RoundedCornerShape(16.dp),
                    colors = CardDefaults.cardColors(
                        containerColor = MaterialTheme.colorScheme.surface
                    ), border = PortalCores.BordaCartao,
                    elevation = CardDefaults.cardElevation(defaultElevation = 8.dp)
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .padding(16.dp),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Text(
                                "Lixeira (7 dias)",
                                style = MaterialTheme.typography.titleLarge,
                                fontWeight = FontWeight.Bold,
                                modifier = Modifier.weight(1f),
                                color = PortalCores.Navy
                            )
                            TextButton(onClick = { aberto = false }) {
                                Text("✕")
                            }
                        }
                        Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            PortalOutlinedButton(onClick = { recarregar() }, enabled = !loading) {
                                Text(if (loading) "Atualizando…" else "Atualizar")
                            }
                        }
                        Text(
                            "Após 7 dias os itens são apagados automaticamente (inspeções também limpam o R2).",
                            style = MaterialTheme.typography.bodySmall,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                        val rolagem197 = androidx.compose.foundation.rememberScrollState()
                        br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(rolagem197, Modifier
                                .weight(1f)
                                .fillMaxWidth()) {
                        Column(
                            modifier = Modifier.fillMaxSize().verticalScroll(rolagem197),
                            verticalArrangement = Arrangement.spacedBy(8.dp)
                        ) {
                            if (!loading && items.isEmpty()) {
                                Text(
                                    "Lixeira vazia.",
                                    style = MaterialTheme.typography.bodyMedium,
                                    color = MaterialTheme.colorScheme.onSurfaceVariant
                                )
                            }
                            items.forEach { item ->
                                TrashItemCard(
                                    item = item,
                                    onRestore = { recuperar(item) },
                                    onPurge = { confirmPurge = item }
                                )
                            }
                        }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun TrashItemCard(
    item: TrashItem,
    onRestore: () -> Unit,
    onPurge: () -> Unit
) {
    Card(
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant),
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            Text(item.label, fontWeight = FontWeight.SemiBold)
            item.subtitle?.takeIf { it.isNotBlank() }?.let {
                Text(it, style = MaterialTheme.typography.bodySmall)
            }
            Text(
                buildString {
                    append("Excluído: ")
                    append(formatDateTimeBr(item.deletedAt))
                    item.deletedByUsername?.takeIf { it.isNotBlank() }?.let {
                        append(" por ")
                        append(it)
                    }
                    item.purgeAt?.let {
                        append(" · expira ")
                        append(formatDateTimeBr(it))
                    }
                },
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                PortalOutlinedButton(onClick = onRestore) { Text("Recuperar") }
                PortalOutlinedButton(onClick = onPurge) { Text("Apagar definitivo") }
            }
        }
    }
}